import React from "react";
import "./Skills.css";

export default function Skills() {
  return (
    <div className="info-section">
      <div className="info-about">
        <h3>
          My <span>Job goals</span>
        </h3>
        <p className="info-about-status">
          <h3>UI/UX Designing/ Research:</h3> To specialize in empathizing with
          users with no bias to create viable optimized Apps that meets their
          needs and requirements. To specialize in creating business value
          through engaging user experiences by implementing valuable design
          processes, user-centered research, interaction, and user testing, to
          validate MIND-BLOWING design decisions.
          <br />
          <br />
          <h3>Project Management:</h3> To deliver quality project based on
          client's need by supporting project team and be a key part in every
          growth stage and project success through effective communication,
          scope definition and validation, managing /engaging stakeholders,
          evaluating risks, adequate monitoring and controlling.Handling
          multiple priorities in a fast paced working environment while solving
          problems to avoid project being behind schedule and above budget.
          Working towards PMP designation/ certification.
          <br />
          <br />
          <h3>Frontend Development: </h3>To implement user-centered responsive
          interface/ design websites using the following languages HTML,CSS,
          JavaScript and React best suited for different devices like mobile,
          desktop, tablets for supported browsers. To build websites following
          SEO best practices, fix bugs, conduct usability tests, optimize user
          experience while improving site interaction regardless of the browser.
          <br />
          <br />
        </p>
      </div>

      <div className="info-content">
        <h1>Skills </h1>
        <p>Design Thinking skills</p>
        <p>User research and Analytical skills</p>
        <p>HTML, CSS, CSS Frameworks JavaScript</p>
        <p>Figma</p>
        <p>Adobe Xd,Photoshop, and Illustrator</p>
        <p>UI/UX Design and Development</p>
        <p>Microsoft office tools including Visio and Ms Project</p>
        <p>React, React Native, React Native Expo, React Next JS</p>
        <p>MongoDB, Firebase firestore</p>
        <p>Swift, Kotlin, Xamarin</p>
        <p>Git/Github,Netlify </p>
        <p>Problem solving skills</p>
        <p>Excellent time management</p>
        <p>5 years of Field service Tech and Project management</p>
      </div>
    </div>
  );
}
